// noinspection ES6UnusedImports
import React, {useRef, useState} from 'react';
import ProductAlternatives from './ProductAlternatives.jsx';
import Landmark from '@core/scripts/components/landmark-adapter';
import {createRoot} from "react-dom/client";
import {IconButton, Link} from "@bonprix/design-system";

export default function ProductAlternativesOpener({item, shopId, productAlternativesText, productAlternativesDataUrl,texts}) {
    // must be included here and not in ShopTheLook.jsx, because children are copied in Slider.jsx and the current item is not accessible there
    if (item.availabilityStatus !== 'SOLDOUT' && !item.soldOut) {
        return null;
    }

    const [currentItemId, _setCurrentItemId] = useState(item.itemId);
    // workaround for event listeners, because inside event listeners only bottom drawer states initial state is accessible.
    // see https://medium.com/geographit/accessing-react-state-in-event-listeners-with-usestate-and-useref-hooks-8cceee73c559 for further information.
    const currentItemIdRef = useRef(currentItemId);
    const setCurrentItemId = (itemId) => {
        currentItemIdRef.current = itemId;
        _setCurrentItemId(itemId);
    };
    const openerRef = useRef();

    const renderProductAlternatives = (itemNumber) => {
        const container = document.createElement('div');
        document.body.querySelector('main').appendChild(container);
        createRoot(container).render(
            <ProductAlternatives
                itemNumber={itemNumber}
                shopId={shopId}
                productAlternativesDataUrl={productAlternativesDataUrl}
                openerRef={openerRef}
                texts={texts}
            />
        );
    };

    const onProductAlternativesClick = () => {
        const itemNumber = item.articleNumber;
        Landmark.sendClickLandmark(`stl_product_alternative\\${itemNumber}`);
        setCurrentItemId(item.itemId);
        renderProductAlternatives(itemNumber);
    };

    return (
        <div className="recommendations__product-alternatives -full-width" onClick={onProductAlternativesClick}>
            <Link
                href="#"
                onClick={(e) => e.preventDefault()}
            >
                {texts.ada_shop_the_look_alternative_product}
            </Link>
            <IconButton small={true} variant="primary" icon="similar-products"/>
        </div>
    );
}
